'use strict';
var parent = require('../../es/json/stringify');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/json/stringify.js
// module id = 771
// module chunks = 13